import styled from 'styled-components'

const ButtonA = styled.button`
  position: relative;
  height: ${props => (props.small ? '30px' : '40px')};
  min-width: ${props => (props.small ? '100px' : '80px')};
  border-radius: 20px;
  background: ${props => (props.disabled ? '#cccccc' : '#F7BE07')};
  background-size: 100%;
  color: ${props => (props.disabled ? '#ffffff' : '#000000')};
  font-weight: 500;
  padding: ${props => (props.small ? '0 22px' : '0 30px')};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  transition: all 0.4s;
  outline: none;
  z-index: 1;
  font-size: ${props => (props.small ? '14px' : '16px')};
  line-height: ${props => (props.small ? '14px' : '16px')};

  &:before {
    border-radius: inherit;
    background-image: linear-gradient(#444, #444);
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    z-index: -100;
    transition: opacity 0.4s;
  }

  &:hover {
    color: #ffffff;
    box-shadow: 0px 4px 2.85px 0.15px rgba(0, 0, 0, 0.1);

    &:before {
      opacity: 1;
    }
  }
`

export default ButtonA



// WEBPACK FOOTER //
// ./src/components/typography/buttons/ButtonA.js